module.exports = __webpack_public_path__ + "img/user-02.a7aa228c.jpg";